import styles from "./styles.module.css";

const Home = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header className={styles.title}>
          <h3>Welcome to the Dashboard</h3>
        </header>
      </div>
    </div>
  );
};

export default Home;
